module.exports = __webpack_public_path__ + "assets/img/site-02.69242822.jpg";